import { LocalStorageKey } from 'shared/constants/localStorage'
import { INNOSCRIPTA_INTERNAL_ORGANIZATION_ID } from 'shared/constants/user'
import { lsGetItem } from 'shared/utils/local-storage/lsGetItem'
import { create } from 'zustand'

export const useCommonStore = create<{
  topDockHeight: number
  isSearchOpen: boolean
  isDetached: boolean
  isClusterMeetOnline: boolean
  demoOrgIds: number[]
  setTopDockHeight: (height: number) => void
  setIsSearchOpen: (isOpen: boolean | ((prev: boolean) => boolean)) => void
  setIsDetached: (isDetached: boolean) => void
  setIsClusterMeetOnline: (isOnline: boolean) => void
  setDemoOrgIds: (data: number[]) => void
  isInternalUser: (
    extraOrganizationIds?: number[],
    onlyAllowDemoAccounts?: boolean
  ) => boolean
}>()((set, get) => ({
  isSearchOpen: false,
  topDockHeight: 0,
  isDetached: false,
  isClusterMeetOnline: false,
  demoOrgIds: [INNOSCRIPTA_INTERNAL_ORGANIZATION_ID],
  setTopDockHeight: height => set({ topDockHeight: height }),
  setIsSearchOpen: isOpen =>
    set(state => ({
      isSearchOpen:
        typeof isOpen === 'function' ? isOpen(state.isSearchOpen) : isOpen
    })),
  setIsDetached: isDetached => set({ isDetached }),
  setIsClusterMeetOnline: isClusterMeetOnline => set({ isClusterMeetOnline }),
  setDemoOrgIds: data => {
    const orgIdSet = new Set<number>(data)

    if (!orgIdSet.has(INNOSCRIPTA_INTERNAL_ORGANIZATION_ID)) {
      orgIdSet.add(INNOSCRIPTA_INTERNAL_ORGANIZATION_ID)
    }

    set({ demoOrgIds: Array.from(orgIdSet) })
  },
  isInternalUser: (
    extraOrganizationIds,
    onlyAllowDemoAccounts = false
  ): boolean => {
    if (!onlyAllowDemoAccounts && !extraOrganizationIds?.length) return false
    const user = lsGetItem(LocalStorageKey.USER)
    if (!user || typeof user.organization_id !== 'number') return false

    const internalOrgIds = get().demoOrgIds
    const allOrgIds = [...internalOrgIds, ...(extraOrganizationIds ?? [])]
    return allOrgIds.includes(user.organization_id)
  }
}))
